import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-navy" data-id="element-88" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-89" data-mp="223em7ne0hd4i">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-emerald-soft border border-gold-light rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-lg" data-id="element-90" data-mp="222dbxl4tkunu">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold" data-id="element-91" data-mp="1j4afwmdutxgj" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-white text-emerald-brand mb-8 border border-emerald-brand/20" data-id="element-92" data-mp="1edu2v3dy4dup">
            <ShieldCheck size={48} data-id="element-93" data-mp="qmybu8hbdmoi" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-navy" data-id="element-94" data-mp="lpg2wi3ar7gi">
            🛡️ 7-Day Refund Policy
          </h2>
          <div className="space-y-6 text-lg text-ink max-w-2xl mx-auto" data-id="element-95" data-mp="oygowo9mduf1">
            <p data-id="element-96" data-mp="ty2ymnq8osj3">You have 7 days to review the material after purchase.</p>
            <p className="font-medium text-navy" data-id="element-97" data-mp="tw9rl7bps6ak">
              If the material you receive is incorrect, defective, incomplete or materially
              different from what was advertised, contact our support team within the applicable
              period and we will review the case according to our refund policy.
            </p>
            <p className="text-sm text-ink-soft mt-8" data-id="element-98" data-mp="ayythq1tjiwp">
              The product is delivered digitally in PDF format.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}